import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { shopify } from "@/lib/api";

/**
 * Renders a Shopify Storefront policy page (refund, privacy, terms, shipping)
 * or a merchant-authored content page (e.g. contact) inside Marcini's editorial
 * layout. Body HTML comes from Shopify, styled via a scoped `.rich-content`
 * class so it inherits the site typography.
 */
export default function ContentPage({ kind }) {
  const { handle } = useParams();

  const isPolicy = kind === "policy";
  const { data: policies } = useQuery({
    queryKey: ["policies"],
    queryFn: () => shopify.policies(),
    enabled: isPolicy,
    staleTime: 5 * 60_000,
  });
  const { data: page } = useQuery({
    queryKey: ["page", handle],
    queryFn: () => shopify.page(handle),
    enabled: !isPolicy && !!handle,
    staleTime: 5 * 60_000,
  });

  const content = isPolicy ? (policies || {})[handle] : page;

  return (
    <div className="pt-24 md:pt-32 px-5 md:px-12 pb-24 md:pb-32 max-w-3xl mx-auto">
      <p className="text-eyebrow mb-3">{isPolicy ? "Vilkår" : "Marcini"}</p>
      <h1 className="font-serif-editorial text-5xl md:text-7xl leading-[0.9] mb-10 md:mb-14">
        {content?.title || "…"}
      </h1>

      {content ? (
        <article
          className="rich-content text-[color:var(--marcini-fg-2)] leading-relaxed text-[15px] md:text-base"
          data-testid={`content-body-${handle}`}
          dangerouslySetInnerHTML={{ __html: content.body }}
        />
      ) : (
        <p className="text-[color:var(--marcini-fg-3)]">…</p>
      )}
    </div>
  );
}
